import React from "react";
import { Box, Typography } from "@mui/material";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import { palette } from "./landing/color";

export default function TableNotFound() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#fff",
        px: 3,
        textAlign: "center",
        color: "#1f1615",
      }}
    >
      <Box sx={{ maxWidth: 420 }}>
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "24px",
            mx: "auto",
            mb: 2,
            display: "grid",
            placeItems: "center",
            bgcolor: "rgba(131, 60, 65, 0.1)",
            color: palette.primary,
          }}
        >
          <TableRestaurantIcon sx={{ fontSize: 36 }} />
        </Box>
        <Typography sx={{ fontSize: 26, fontWeight: 800, mb: 1 }}>
          Table not found
        </Typography>
        <Typography sx={{ color: "#7a6560", fontSize: 15, lineHeight: 1.6 }}>
          This QR code does not match an active table for this restaurant.
          Please ask a restaurant attendant for the correct table QR code.
        </Typography>
      </Box>
    </Box>
  );
}
